<template>
  <div class="c-dropdown" @mouseenter="$emit('openning', SET_LOADING)">
    <slot name="title"></slot>
    <div
      v-if="!hiddenDropdown"
      class="c-dropdown__content"
      :class="{
        [`c-dropdown__content--${size}`]: size,
        'c-dropdown__content--icon-title-right': iconTitleRight,
        'c-dropdown__content--right': align === 'right',
        'c-dropdown__content--left': align === 'left',
        'c-dropdown__content--radius-bottom': radiusBottom,
      }"
    >
      <loading v-if="isLoading"></loading>
      <slot v-else name="content"></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    align: {
      default: "left",
    },
    size: {
      default: "left",
    },
    iconTitleRight: {
      default: false,
      type: Boolean,
    },
    hiddenDropdown: {
      default: false,
      type: Boolean,
    },
    radiusBottom: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    SET_LOADING(loading = true) {
      this.isLoading = loading;
    },
  },
};
</script>

<style></style>
